import React, { type ComponentType, createElement } from 'react';

import {
  type ModalComponentCommonProps,
  type ModalType,
  modalInstanceRegistry,
  useModalActions,
  useModalStack,
} from '@shared/lib/modal';

import { modalComponentRegistry } from './modalComponentRegistry';

const renderModal = (id: string, type: ModalType, onClose: () => void) => {
  const props = modalInstanceRegistry.getProps(id) as object | undefined;

  if (!props) return null;

  const Component = modalComponentRegistry[type] as ComponentType<ModalComponentCommonProps>;

  return createElement(Component, { ...props, key: id, open: true, onClose });
};

export const ModalRenderer: React.FC = () => {
  const stack = useModalStack();
  const { closeModal } = useModalActions();

  return <>{stack.map(({ id, type }) => renderModal(id, type, () => closeModal(id)))}</>;
};
